// extracted by mini-css-extract-plugin
export var buttonGroup = "ConfirmDialog-module--buttonGroup--17a5c";
export var container = "ConfirmDialog-module--container--e3243";
export var dialog = "ConfirmDialog-module--dialog--06b03";
export var left = "ConfirmDialog-module--left--651fb";
export var message = "ConfirmDialog-module--message--452f6";
export var overlay = "ConfirmDialog-module--overlay--399bc";
export var vertical = "ConfirmDialog-module--vertical--a98ab";